/**
 * ゲームモード(normal か oni)
 */
export const MODE = {
  normal: 'normal',
} as const;

/**
 * 結果ページのパス
 */
export const RESULT_PAGE_PATH = {
  NORMAL: '/result',
};

/**
 * TODO: 本来であれば.envに書くべきだが、現在は環境変数が使えないためここに書く
 */
export const APP_URL = 'https://eigoryoku.nhk-book.co.jp';
export const BASE_URL_SHARE = `${APP_URL}/share/`;

export const SHARE_IMAGE_PARTS_PATH = (
  score: number,
  ranking: number,
  level: number,
  name: string,
) => `${score}/${ranking}/${level}/${encodeURIComponent(name)}/`;
export const DEFAULT_OPEN_BROWSER_PARAMETER = 'openExternalBrowser=1';

/**
 * NHKテキスト 実運用LINE URL
 * @see https://sonicmoov.backlog.jp/wiki/SMV_NHKTEXT/Home
 */
export const LINE_URL = 'https://lin.ee/kpw6f9o';

/**
 * ニックネーム バリデーションエラー文言
 */
export const NICKNAME_VALIDATION = {
  required: {
    rule: true,
    text: 'ニックネームを入力してください',
  },
  matches: {
    rule: /^[A-Za-z0-9ぁ-んァ-ン一-龥々ヶ０-９Ａ-Ｚａ-ｚｦ-ﾟ\u30FC]+$/,
    text: 'ニックネームは、10文字以下（記号不可）を指定ください',
  },
  max: {
    rule: 10,
    text: 'ニックネームは、10文字以下（記号不可）を指定ください',
  },
} as const;

/**
 * ニックネーム
 * 上の句と下の句
 */
export const NICKNAME = {
  first: [
    'あおい',
    'あかい',
    'きいろい',
    'しろい',
    'くろい',
    'ピンクの',
    'みどりの',
    'みずいろの',
    'むらさきの',
    'オレンジの',
    'ちゃいろの',
    'はいいろの',
    'きんの',
    'ぎんの',
    'にじいろの',
    'まっかな',
    'まっさおな',
    'まっしろな',
    'まっくろな',
    'まみどりな',
    '青い',
    '赤い',
    '黄色い',
    '白い',
    '黒い',
    '桃色の',
    '緑の',
    '水色の',
    '紫の',
    '橙の',
    '茶色の',
    '灰色の',
    '金の',
    '銀の',
    '虹色の',
    '真っ赤な',
    '真っ青な',
    '真っ白な',
    '真っ黒な',
    '真緑な',
    'あつい',
    'あしたの',
    'あそこの',
    'あの',
    'あまい',
    'あやふやな',
    'あらい',
    'あわい',
    'いつもの',
    'いろんな',
    'うすい',
    'うちゅうの',
    'うぶな',
    'うまい',
    'うれしい',
    'えらい',
    'おいしい',
    'おおきい',
    'おおらかな',
    'おしゃれな',
    'おそい',
    'おぼろげな',
    'おもい',
    'おもしろい',
    'かがやく',
    'かこの',
    'かたい',
    'かっこいい',
    'かつての',
    'かるい',
    'かわいい',
    'きせきの',
    'きのうの',
    'きゃしゃな',
    'きょうの',
    'くらい',
    'このまえの',
    'こわい',
    'ささやかな',
    'さすらいの',
    'さまざまな',
    'さまよう',
    'さむい',
    'さわやかな',
    'しがない',
    'しとやかな',
    'しなやかな',
    'しぶい',
    'じょうぶな',
    'すごい',
    'すばやい',
    'するどい',
    'せまい',
    'そっくりな',
    'その',
    'たかい',
    'たのもしい',
    'たびびとの',
    'ちいさい',
    'つよい',
    'でかい',
    'でんせつの',
    'となりの',
    'ながい',
    'ぬるい',
    'ねむい',
    'はかない',
    'はでな',
    'はやい',
    'ひかる',
    'ひくい',
    'ひろい',
    'ふかい',
    'ふたごの',
    'ふつうの',
    'ふとい',
    'ふるい',
    'ほそい',
    'まじめな',
    'まぶしい',
    'まおうの',
    'まほうの',
    'まめな',
    'まるい',
    'まれな',
    'みらいの',
    'やすい',
    'ゆうしゃの',
    'ゆるい',
    'わかい',
    '明日の',
    '甘い',
    '荒い',
    '淡い',
    '色んな',
    '薄い',
    '宇宙の',
    '初心な',
    '上手い',
    '嬉しい',
    '偉い',
    '美味しい',
    '大きい',
    '大らかな',
    'お洒落な',
    '遅い',
    '朧げな',
    '重い',
    '面白い',
    '輝く',
    '過去の',
    '固い',
    '格好いい',
    '軽い',
    '可愛い',
    '奇跡の',
    '昨日の',
    '華奢な',
    '今日の',
    '暗い',
    'この前の',
    '怖い',
    '細やかな',
    '流離の',
    '様々な',
    '彷徨う',
    '寒い',
    '爽やかな',
    '淑やかな',
    '渋い',
    '丈夫な',
    '凄い',
    '素早い',
    '鋭い',
    '狭い',
    'ソックリな',
    '其の',
    '高い',
    '頼もしい',
    '旅人の',
    '小さい',
    '強い',
    'デカイ',
    '伝説の',
    '隣の',
    '長い',
    '温い',
    '眠い',
    '儚い',
    '派手な',
    '早い',
    '光る',
    '低い',
    '広い',
    '深い',
    '双子の',
    '普通の',
    '太い',
    '古い',
    '細い',
    '真面目な',
    '眩しい',
    '魔王の',
    '魔法の',
    'マメな',
    '丸い',
    '稀な',
    '未来の',
    '安い',
    '勇者の',
    '緩い',
    '若い',
  ],
  second: [
    'アザラシ',
    'あざらし',
    'アサガオ',
    'あさがお',
    'アヒル',
    'あひる',
    'アジサイ',
    'あじさい',
    'アライグマ',
    'あらいぐま',
    'アネモネ',
    'あねもね',
    'アリクイ',
    'ありくい',
    'アマリリス',
    'あまりりす',
    'アルパカ',
    'あるぱか',
    'アヤメ',
    'あやめ',
    'イカ',
    'いか',
    'イチゴ',
    'いちご',
    'イタチ',
    'いたち',
    'ウメ',
    'うめ',
    'イヌ',
    'いぬ',
    'オオガハス',
    'おおがはす',
    'イノシシ',
    'いのしし',
    'オオバコ',
    'おおばこ',
    'イモリ',
    'いもり',
    'オトメユリ',
    'おとめゆり',
    'イルカ',
    'いるか',
    'ガーベラ',
    'がーべら',
    'インコ',
    'いんこ',
    'カキ',
    'かき',
    'ウグイス',
    'うぐいす',
    'カキツバタ',
    'かきつばた',
    'ウサギ',
    'うさぎ',
    'カタクリ',
    'かたくり',
    'ウツボ',
    'うつぼ',
    'カタバミ',
    'かたばみ',
    'ウミウシ',
    'うみうし',
    'カトレア',
    'かとれあ',
    'ウミガメ',
    'うみがめ',
    'カノコユリ',
    'かのこゆり',
    'ウミネコ',
    'うみねこ',
    'カボチャ',
    'かぼちゃ',
    'エイ',
    'えい',
    'キキョウ',
    'ききょう',
    'エゾシカ',
    'えぞしか',
    'キク',
    'きく',
    'オウム',
    'おうむ',
    'キタコブシ',
    'きたこぶし',
    'オコジョ',
    'おこじょ',
    'キュウリ',
    'きゅうり',
    'カジキ',
    'かじき',
    'キリ',
    'きり',
    'カッコウ',
    'かっこう',
    'キンシバイ',
    'きんしばい',
    'カニ',
    'かに',
    'キンセンカ',
    'きんせんか',
    'カバ',
    'かば',
    'カピバラ',
    'かぴばら',
    'クズ',
    'くず',
    'カメ',
    'かめ',
    'クリ',
    'くり',
    'カメレオン',
    'かめれおん',
    'クレマチス',
    'くれまちす',
    'カモ',
    'かも',
    'クロッカス',
    'くろっかす',
    'カモシカ',
    'かもしか',
    'クロユリ',
    'くろゆり',
    'カモメ',
    'かもめ',
    'ケイトウ',
    'けいとう',
    'カラス',
    'からす',
    'ゲッカコウ',
    'げっかこう',
    'カワウソ',
    'かわうそ',
    'コケモモ',
    'こけもも',
    'キーウィ',
    'きーうぃ',
    'コスモス',
    'こすもす',
    'キジ',
    'きじ',
    'コブシ',
    'こぶし',
    'キツツキ',
    'きつつき',
    'コマクサ',
    'こまくさ',
    'キツネ',
    'きつね',
    'サクラ',
    'さくら',
    'キリン',
    'きりん',
    'サクラソウ',
    'さくらそう',
    'クジャク',
    'くじゃく',
    'サザンカ',
    'さざんか',
    'クジラ',
    'くじら',
    'ザゼンソウ',
    'ざぜんそう',
    'クマ',
    'くま',
    'サツキ',
    'さつき',
    'クマノミ',
    'くまのみ',
    'サルスベリ',
    'さるすべり',
    'クモ',
    'くも',
    'サルビア',
    'さるびあ',
    'クラゲ',
    'くらげ',
    'シクラメン',
    'しくらめん',
    'クリオネ',
    'くりおね',
    'シャクナゲ',
    'しゃくなげ',
    'コアラ',
    'こあら',
    'シャクヤク',
    'しゃくやく',
    'コウモリ',
    'こうもり',
    'ジャスミン',
    'じゃすみん',
    'コーギー',
    'こーぎー',
    'シラユリ',
    'しらゆり',
    'コネコ',
    'こねこ',
    'シラン',
    'しらん',
    'コブラ',
    'こぶら',
    'スイセン',
    'すいせん',
    'コヨーテ',
    'こよーて',
    'スイレン',
    'すいれん',
    'ゴリラ',
    'ごりら',
    'スズラン',
    'すずらん',
    'サーバル',
    'さーばる',
    'スダチ',
    'すだち',
    'サザエ',
    'さざえ',
    'スミレ',
    'すみれ',
    'サソリ',
    'さそり',
    'ゼラニウム',
    'ぜらにうむ',
    'サル',
    'さる',
    'ダリア',
    'だりあ',
    'シイラ',
    'しいら',
    'タンポポ',
    'たんぽぽ',
    'シカ',
    'しか',
    'チゴユリ',
    'ちごゆり',
    'シバイヌ',
    'しばいぬ',
    'ツツジ',
    'つつじ',
    'シマウマ',
    'しまうま',
    'ツバキ',
    'つばき',
    'シマリス',
    'しまりす',
    'ツユクサ',
    'つゆくさ',
    'ジャガー',
    'じゃがー',
    'デイジー',
    'でいじー',
    'シャチ',
    'しゃち',
    'トマト',
    'とまと',
    'ジュゴン',
    'じゅごん',
    'トリカブト',
    'とりかぶと',
    'スカンク',
    'すかんく',
    'ナシ',
    'なし',
    'スズメ',
    'すずめ',
    'ナス',
    'なす',
    'セイウチ',
    'せいうち',
    'ナズナ',
    'なずな',
    'ゾウ',
    'ぞう',
    'ナデシコ',
    'なでしこ',
    'タカ',
    'たか',
    'ナノハナ',
    'なのはな',
    'ダチョウ',
    'だちょう',
    'ニラ',
    'にら',
    'タヌキ',
    'たぬき',
    'ニンニク',
    'にんにく',
    'チーター',
    'ちーたー',
    'ネギ',
    'ねぎ',
    'チドリ',
    'ちどり',
    'ネジバナ',
    'ねじばな',
    'チョウ',
    'ちょう',
    'ネムノキ',
    'ねむのき',
    'チワワ',
    'ちわわ',
    'ノアザミ',
    'のあざみ',
    'チンアナゴ',
    'ちんあなご',
    'ノバラ',
    'のばら',
    'チンチラ',
    'ちんちら',
    'バウヒニア',
    'ばうひにあ',
    'ツバメ',
    'つばめ',
    'ハギ',
    'はぎ',
    'ツル',
    'つる',
    'ハコベ',
    'はこべ',
    'デグー',
    'でぐー',
    'ハス',
    'はす',
    'トカゲ',
    'とかげ',
    'ハナズオウ',
    'はなずおう',
    'トド',
    'とど',
    'ハナニラ',
    'はなにら',
    'トナカイ',
    'となかい',
    'ハナミズキ',
    'はなみずき',
    'トラ',
    'とら',
    'ハマギク',
    'はまぎく',
    'トンビ',
    'とんび',
    'ハマナス',
    'はまなす',
    'ナマケモノ',
    'なまけもの',
    'バラ',
    'ばら',
    'ニワトリ',
    'にわとり',
    'ハルジオン',
    'はるじおん',
    'ネコ',
    'ねこ',
    'パンジー',
    'ぱんじー',
    'ねずみ',
    'ねずみ',
    'ピーマン',
    'ぴーまん',
    'ハイエナ',
    'はいえな',
    'ヒガンバナ',
    'ひがんばな',
    'バイソン',
    'ばいそん',
    'ヒナゲシ',
    'ひなげし',
    'ハチドリ',
    'はちどり',
    'ヒマワリ',
    'ひまわり',
    'ハト',
    'はと',
    'ヒメアヤメ',
    'ひめあやめ',
    'パフィン',
    'ぱふぃん',
    'ハムスター',
    'はむすたー',
    'ヒヤシンス',
    'ひやしんす',
    'ハヤブサ',
    'はやぶさ',
    'ヒルガオ',
    'ひるがお',
    'ハリネズミ',
    'はりねずみ',
    'フキ',
    'ふき',
    'パンダ',
    'ぱんだ',
    'フジ',
    'ふじ',
    'ビーグル',
    'びーぐる',
    'ブッソウゲ',
    'ぶっそうげ',
    'ヒグマ',
    'ひぐま',
    'フヨウ',
    'ふよう',
    'ヒツジ',
    'ひつじ',
    'フリージア',
    'ふりーじあ',
    'ヒョウ',
    'ひょう',
    'ベゴニア',
    'べごにあ',
    'プードル',
    'ぷーどる',
    'ベニバナ',
    'べにばな',
    'フェレット',
    'ふぇれっと',
    'ヘレボラス',
    'へれぼらす',
    'フクロウ',
    'ふくろう',
    'ホウセンカ',
    'ほうせんか',
    'ブタ',
    'ぶた',
    'ホオズキ',
    'ほおずき',
    'ペリカン',
    'ぺりかん',
    'ボケ',
    'ぼけ',
    'ペンギン',
    'ぺんぎん',
    'ボタン',
    'ぼたん',
    'ポニー',
    'ぽにー',
    'ホトケノザ',
    'ほとけのざ',
    'マナティ',
    'まなてぃ',
    'ホトトギス',
    'ほととぎす',
    'マンボウ',
    'まんぼう',
    'ポピー',
    'ぽぴー',
    'マンモス',
    'まんもす',
    'ボロニア',
    'ぼろにあ',
    'ミツバチ',
    'みつばち',
    'ミカン',
    'みかん',
    'ミミズク',
    'みみずく',
    'ムクゲ',
    'むくげ',
    'メンダコ',
    'めんだこ',
    'モクレン',
    'もくれん',
    'モグラ',
    'もぐら',
    'モモ',
    'もも',
    'モルモット',
    'もるもっと',
    'ヤエザクラ',
    'やえざくら',
    'ヤギ',
    'やぎ',
    'ヤマブキ',
    'やまぶき',
    'ヤドカリ',
    'やどかり',
    'ヤマユリ',
    'やまゆり',
    'ヤマネコ',
    'やまねこ',
    'ユウガオ',
    'ゆうがお',
    'ヤモリ',
    'やもり',
    'ユキノシタ',
    'ゆきのした',
    'ライオン',
    'らいおん',
    'ユキヤナギ',
    'ゆきやなぎ',
    'ライチョウ',
    'らいちょう',
    'ユリ',
    'ゆり',
    'ラッコ',
    'らっこ',
    'ヨルガオ',
    'よるがお',
    'リス',
    'りす',
    'ライラック',
    'らいらっく',
    'ロバ',
    'ろば',
    'ラベンダー',
    'らべんだー',
    'ワシ',
    'わし',
    'ラン',
    'らん',
    'ワニ',
    'わに',
    'リラ',
    'りら',
    'リンゴ',
    'りんご',
    'リンドウ',
    'りんどう',
    'ルドベキア',
    'るどべきあ',
    'ルピナス',
    'るぴなす',
    'レンゲソウ',
    'れんげそう',
  ],
} as const;
